import { endpointService } from "components/shared/services/endpointService";
import {
  ParticipantEndpointConfig,
  PickupParticipantKind,
  PickupParticipantVariant,
} from "./types";

export const PAGE_SIZE = 10;

export const getConfig = (
  kind: PickupParticipantKind,
  variant: PickupParticipantVariant,
): ParticipantEndpointConfig => {
  const isSport = kind === "sport";
  const isWps = variant === "wps";

  if (isWps) {
    const resourceName = isSport ? "sport-participants" : "attraction-participants";
    const resourceEndpoint = endpointService.getCheckinEndpoint(
      isSport ? "sportParticipantResource" : "attractionParticipantResource",
    );
    const basePath = `/check-in/${resourceName}`;
    return {
      listResource: resourceEndpoint,
      detailResource: resourceEndpoint,
      idsResource: endpointService.getCheckinEndpoint(
        isSport ? "sportParticipantIds" : "attractionParticipantIds",
      ),
      eventsResource: endpointService.getCheckinEndpoint(
        isSport ? "sportParticipantEvents" : "attractionParticipantEvents",
      ),
      categoriesResource: (eventId) =>
        endpointService.getCheckinEndpoint(
          isSport ? "sportParticipantCategories" : "attractionParticipantCategories",
          { eventId },
        ),
      exportResource: endpointService.getCheckinEndpoint(
        isSport ? "sportParticipantExport" : "attractionParticipantExport",
      ),
      exportPartnerResource: endpointService.getCheckinEndpoint(
        isSport ? "sportParticipantExportForPartner" : "attractionParticipantExportForPartner",
      ),
      exportResultResource: endpointService.getCheckinEndpoint(
        isSport ? "sportParticipantExportResultResource" : "attractionParticipantExportResultResource",
      ),
      deleteResource: resourceEndpoint,
      deleteValues: (ids) => ({ participant_ids: ids }),
      idsFilters: (filters) =>
        filters.map((filter: any) =>
          filter.field === "search" ? { ...filter, field: "q" } : filter,
        ),
      historyResource: (participantId) =>
        endpointService.getCheckinEndpoint(
          isSport ? "sportParticipantHistory" : "attractionParticipantHistory",
          { participantId },
        ),
      permissionResource: resourceName,
      permissionApp: "check-in",
      basePath,
      detailPath: (participantId) => `${basePath}/${participantId}/detail`,
      editPath: (participantId) => `${basePath}/${participantId}/edit`,
      eventType: isSport ? "sports" : "attractions",
    };
  }

  const resourceName = isSport ? "sport_participants" : "attraction_participants";
  const basePath = `/pickup/${isSport ? "sport-participants" : "attraction-participants"}`;
  return {
    listResource: endpointService.getCheckinEndpoint(
      isSport ? "adminSportParticipantList" : "adminAttractionParticipantList",
    ),
    detailResource: endpointService.getCheckinEndpoint(
      isSport ? "adminParticipantDetail" : "adminAttractionParticipantDetail",
    ),
    idsResource: endpointService.getCheckinEndpoint("adminParticipantIds"),
    eventsResource: endpointService.getCheckinEndpoint("adminEventDropdown", {
      eventType: isSport ? "sports" : "attractions",
    }),
    categoriesResource: (eventId) =>
      endpointService.getCheckinEndpoint("adminCategoryDropdown", {
        eventId,
      }),
    exportResource: isSport
      ? endpointService.getCheckinEndpoint("adminSportParticipantExport")
      : endpointService.getCheckinEndpoint("adminAttractionParticipantExport"),
    exportPartnerResource: isSport
      ? endpointService.getCheckinEndpoint("adminSportParticipantExport")
      : endpointService.getCheckinEndpoint("adminAttractionParticipantExport"),
    exportResultResource: endpointService.getCheckinEndpoint("adminExportResult"),
    deleteResource: endpointService.getCheckinEndpoint("adminParticipantDelete"),
    deleteValues: (ids) => ({
      participant_type: isSport ? "sports" : "attractions",
      participant_ids: ids,
    }),
    idsFilters: (filters) =>
      isSport
        ? filters
        : filters.concat([{ field: "participant_type", operator: "eq", value: "attractions" }]),
    historyResource: (participantId) =>
      endpointService.getCheckinEndpoint(
        isSport ? "adminSportParticipantHistory" : "adminAttractionParticipantHistory",
        { participantId },
      ),
    permissionResource: resourceName,
    permissionApp: "pickup",
    basePath,
    detailPath: (participantId) => `${basePath}/${participantId}`,
    editPath: (participantId) => `${basePath}/${participantId}/edit`,
    eventType: isSport ? "sports" : "attractions",
  };
};
